import type { Control, UseControllerProps } from 'react-hook-form';
import { useController } from 'react-hook-form';

import type { ReadFieldProps } from '../ReadField';
import { ReadField } from '../ReadField';

type IControlledReadFieldProps = Omit<ReadFieldProps<any>, 'value'> &
    Omit<UseControllerProps<any>, 'control'> & {
        control: Control<any, any>;
    };

export const ControlledReadField = ({ name, control, ...rest }: IControlledReadFieldProps) => {
    const { field } = useController({
        name,
        control,
    });

    return <ReadField value={field.value} {...rest} />;
};

ControlledReadField.displayName = 'ControlledReadField';
